import { sessionStorageInstance } from '@gem/modules/storage';

const getOAuthReturnUrlStorageKey = (state: string): string => {
  return `oauth:returnUrl:${state}`;
};

export const setOAuthReturnUrl = (state: string, returnUrl: string): void => {
  if (!state || !returnUrl) {
    return;
  }

  const storageKey = getOAuthReturnUrlStorageKey(state);
  sessionStorageInstance.setItem(storageKey, returnUrl);
};

export const getOAuthReturnUrl = (state: string | null): string => {
  if (!state) {
    return '';
  }

  const storageKey = getOAuthReturnUrlStorageKey(state);
  return sessionStorageInstance.getItem(storageKey) || '';
};

export const clearOAuthReturnUrl = (state: string | null): void => {
  if (!state) {
    return;
  }

  const storageKey = getOAuthReturnUrlStorageKey(state);
  sessionStorageInstance.removeItem(storageKey);
};
